import React, { useState } from "react";
import TermsOfUse from "../Modal/TermsOfUse";
import KvkkModal from "./KvkkModal";

export default function Footer() {
  const [isKvkkModalOpen, setIsKvkkModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);

  const openKvkk = (event) => {
    if (event) {
      event.preventDefault();
    }
    setIsKvkkModalOpen(true);
  };

  const closeKvkk = () => {
    setIsKvkkModalOpen(false);
  };

  const openTerms = (event) => {
    if (event) {
      event.preventDefault();
    }
    setIsTermsModalOpen(true);
  };

  const closeTerms = () => {
    setIsTermsModalOpen(false);
  };

  return (
    <>
      <footer className="t-appFooter">
        <div className="t-appFooter-inner">
          <nav className="t-appFooter-links" aria-label="Alt bağlantılar">
            <button type="button" className="t-appFooter-link t-appFooter-link--button" onClick={openTerms}>
              Kullanım Koşulları
            </button>
            <span className="t-appFooter-separator" aria-hidden="true" />
            <button type="button" className="t-appFooter-link t-appFooter-link--button" onClick={openKvkk}>
              Kişisel Verilerin Korunması
            </button>
            <span className="t-appFooter-separator" aria-hidden="true" />
            <a
              href="https://www.eminevim.com/subeler"
              target="_blank"
              rel="noopener noreferrer"
              className="t-appFooter-link"
            >
              Şubelerimiz
            </a>
          </nav>
        </div>
      </footer>
      <TermsOfUse isOpen={isTermsModalOpen} onClose={closeTerms} />
      <KvkkModal isOpen={isKvkkModalOpen} onClose={closeKvkk} />
    </>
  );
}
